import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';

const projects = [
  {
    id: 12,
    title: 'Solune',
    category: 'E-Commerce',
    iconName: 'ShoppingBag',
    views: '18.7k',
    likes: '4.3k',
    img: 'https://cdn.jiro.build/Natural%20Glow/Images/Header%20sm%20image.png',
    url: '/portfolio/solune',
    internal: true
  },
  {
    id: 11,
    title: 'PayUp',
    category: 'Web Development',
    iconName: 'CreditCard',
    views: '45.2k',
    likes: '12.4k',
    img: 'https://res.cloudinary.com/dfg8nrgvf/image/upload/v1784140732/CleanShot_2026-07-16_at_02.38.34_2x_ohclq5.png',
    url: '/portfolio/payup',
    internal: true
  },
  {
    id: 10,
    title: 'Echox',
    category: 'E-Commerce',
    iconName: 'Speaker',
    views: '32.4k',
    likes: '8.9k',
    img: 'https://res.cloudinary.com/dfg8nrgvf/image/upload/v1783999246/CleanShot_2026-07-14_at_11.20.35_2x_m1kjan.png',
    url: '/portfolio/echox',
    internal: true
  },
  {
    id: 9,
    title: 'Laounge Coffee',
    category: 'Web Development',
    iconName: 'Coffee',
    views: '24.1k',
    likes: '5.6k',
    img: 'https://res.cloudinary.com/dfg8nrgvf/image/upload/v1783997654/CleanShot_2026-07-14_at_10.53.49_2x_mqbawm.png',
    url: '/portfolio/cafe',
    internal: true
  },
  {
    id: 1,
    title: 'FitPair',
    category: 'Mobile Apps',
    iconName: 'Smartphone',
    views: '12.5k',
    likes: '2.4k',
    img: 'https://res.cloudinary.com/dfg8nrgvf/image/upload/v1783605515/CleanShot_2026-07-09_at_21.43.51_2x_hpzzjx.png',
    url: 'https://fit-pair.com',
    internal: false
  },
  {
    id: 2,
    title: 'Ceylanthro',
    category: 'E-Commerce',
    iconName: 'ShoppingCart',
    views: '18.2k',
    likes: '3.1k',
    img: 'https://res.cloudinary.com/dfg8nrgvf/image/upload/v1783608406/CleanShot_2026-07-09_at_22.45.59_2x_mzjhxl.png',
    url: 'https://ceylanthro.com/',
    internal: false
  },
  {
    id: 3,
    title: 'Maison De Charm',
    category: 'Web Development',
    iconName: 'Layout',
    views: '9.3k',
    likes: '1.8k',
    img: 'https://res.cloudinary.com/dfg8nrgvf/image/upload/v1783615207/CleanShot_2026-07-10_at_00.39.50_2x_rdb8kq.png',
    url: 'https://maisondecharm.com',
    internal: false
  },
  {
    id: 4,
    title: 'Alpha Training Consultancy',
    category: 'Web Development',
    iconName: 'Globe',
    views: '15.1k',
    likes: '4.2k',
    img: 'https://res.cloudinary.com/dfg8nrgvf/image/upload/v1783618134/CleanShot_2026-07-10_at_01.28.37_2x_ium9kt.png',
    url: 'https://alphatcsg.com',
    internal: false
  },
  {
    id: 5,
    title: 'White Knight Global Consultancy',
    category: 'Web Development',
    iconName: 'Shield',
    views: '11.8k',
    likes: '3.6k',
    img: 'https://res.cloudinary.com/dfg8nrgvf/image/upload/v1783617519/CleanShot_2026-07-10_at_01.18.19_2x_lpodla.png',
    url: 'https://whiteknightgc.com',
    internal: false
  },
  {
    id: 6,
    title: 'Roaming Logos',
    category: 'Web App',
    iconName: 'Navigation',
    views: '8.4k',
    likes: '1.2k',
    img: 'https://res.cloudinary.com/dfg8nrgvf/image/upload/v1779211733/Remove_Background_e9npzp.png',
    url: 'https://roaminglogos.com/',
    internal: false
  },
  {
    id: 8,
    title: 'BookOTG',
    category: 'Mobile Apps',
    iconName: 'Book',
    views: '22.4k',
    likes: '5.1k',
    img: 'https://res.cloudinary.com/dfg8nrgvf/image/upload/v1783618646/CleanShot_2026-07-10_at_01.37.01_2x_m2zyxl.png',
    url: 'https://bookotg.com',
    internal: false
  },
  {
    id: 13,
    title: 'Leopard Bliss Yala',
    category: 'Web Development',
    iconName: 'Globe',
    views: 'New',
    likes: 'New',
    img: 'https://cloud.sharemyimage.com/2026/10/29/CleanShot-2026-10-29-at-10.51.46-AM2x.png',
    url: 'https://leopardblissyala.com',
    internal: false
  },
  {
    id: 14,
    title: 'Zevi.lk',
    category: 'E-Commerce',
    iconName: 'ShoppingCart',
    views: 'New',
    likes: 'New',
    img: 'https://cloud.sharemyimage.com/2026/10/29/CleanShot-2026-10-29-at-10.53.55-AM2x.png',
    url: 'https://zevi.lk',
    internal: false
  },
  {
    id: 15,
    title: 'dat.hostfig.com',
    category: 'Web Development',
    iconName: 'Globe',
    views: 'New',
    likes: 'New',
    img: 'https://cloud.sharemyimage.com/2026/10/29/CleanShot-2026-10-29-at-10.55.26-AM2x.png',
    url: 'https://dat.hostfig.com',
    internal: false
  },
  {
    id: 16,
    title: 'dekka.lk',
    category: 'E-Commerce',
    iconName: 'ShoppingCart',
    views: 'New',
    likes: 'New',
    img: 'https://cloud.sharemyimage.com/2026/10/29/CleanShot-2026-10-29-at-10.56.21-AM2x.png',
    url: 'https://dekka.lk',
    internal: false
  },
  {
    id: 17,
    title: 'kandsons.hostfig.com',
    category: 'Web Development',
    iconName: 'Globe',
    views: 'New',
    likes: 'New',
    img: 'https://cloud.sharemyimage.com/2026/10/29/CleanShot-2026-10-29-at-10.57.37-AM2x.png',
    url: 'https://kandsons.hostfig.com',
    internal: false
  },
  {
    id: 18,
    title: 'otterworks.hostfig.com',
    category: 'Web Development',
    iconName: 'Globe',
    views: 'New',
    likes: 'New',
    img: 'https://cloud.sharemyimage.com/2026/10/29/CleanShot-2026-10-29-at-10.58.36-AM2x.png',
    url: 'https://otterworks.hostfig.com',
    internal: false
  },
  {
    id: 19,
    title: 'paraadventures.com',
    category: 'Web Development',
    iconName: 'Globe',
    views: 'New',
    likes: 'New',
    img: 'https://cloud.sharemyimage.com/2026/10/29/CleanShot-2026-10-29-at-11.03.57-AM2x.png',
    url: 'https://paraadventures.com',
    internal: false
  }
];

const categories = ['All', 'Web Development', 'E-Commerce', 'Mobile Apps', 'Web App'];
const allCategoryPriority = [13, 2, 11];

const PortfolioSection = () => {
  const [activeCategory, setActiveCategory] = useState('All');
  const navigate = useNavigate();

  const filteredProjects = projects.filter(
    (p) => activeCategory === 'All' || p.category === activeCategory
  );

  const displayedProjects = activeCategory === 'All'
    ? [...filteredProjects]
        .sort((a, b) => {
          const aPriority = allCategoryPriority.indexOf(a.id);
          const bPriority = allCategoryPriority.indexOf(b.id);
          return (aPriority === -1 ? allCategoryPriority.length : aPriority)
            - (bPriority === -1 ? allCategoryPriority.length : bPriority);
        })
        .slice(0, 3)
    : filteredProjects.slice(0, 3);

  const handleProjectClick = (project) => {
    if (project.internal) {
      navigate(project.url);
    } else {
      window.open(project.url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <section id="section-portfolio" className="w-full bg-slate-50 pt-24 pb-0 px-6 md:px-12 lg:px-24 relative overflow-hidden font-sans border-t border-slate-100">
      <div className="max-w-[1248px] mx-auto mb-12 md:mb-16 flex flex-col lg:flex-row lg:items-end justify-between gap-8 relative z-20">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          className="flex flex-col gap-3 md:gap-4"
        >
          <h2 className="text-slate-900 text-[28px] sm:text-[36px] md:text-[52px] font-bold leading-[1.2] md:leading-[1.1] tracking-[-1px] md:tracking-[-1.8px] flex items-center flex-wrap gap-x-2 md:gap-x-3">
            Our{' '}
            <span className="relative inline-block px-2 md:px-3 py-1">
              <span className="absolute inset-0 bg-blue-100 rounded-lg -z-10"></span>
              <span className="text-blue-600 relative z-10">
                Work
              </span>
            </span>
          </h2>
          <p className="text-slate-600 text-[16px] md:text-[18px] font-normal">
            Explore digital experiences engineered for growth.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2, ease: "easeOut" }}
          className="flex flex-col sm:flex-row items-start sm:items-center gap-4"
        >
          <div className="flex bg-white border border-slate-200 p-1 rounded-xl w-full sm:w-auto overflow-x-auto shadow-sm hide-scrollbar">
            {categories.map((cat) => (
              <button
                key={cat}
                onClick={() => setActiveCategory(cat)}
                className={`flex items-center gap-2 px-4 py-2 text-xs md:text-sm font-semibold transition-all duration-300 rounded-lg whitespace-nowrap ${
                  activeCategory === cat
                    ? 'bg-slate-900 text-white shadow-sm'
                    : 'text-slate-500 hover:text-slate-900 hover:bg-slate-50'
                }`}
              >
                {cat}
              </button>
            ))}
          </div>
        </motion.div>
      </div>

      <div className="max-w-[1248px] mx-auto relative z-20">
        <motion.div layout className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-[32px] md:gap-y-[40px] gap-x-[24px]">
          <AnimatePresence mode="popLayout">
            {displayedProjects.map((project, index) => (
              <motion.div
                key={project.id}
                layout
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, scale: 0.95 }}
                transition={{ duration: 0.4, delay: index * 0.05, ease: "easeOut" }}
                className="cursor-pointer group flex flex-col gap-[16px] md:gap-[20px]"
                onClick={() => handleProjectClick(project)}
              >
                <div className="w-full h-[200px] sm:h-[240px] border border-slate-200 rounded-2xl overflow-hidden relative shadow-sm bg-white">
                  <img
                    src={project.img}
                    alt={project.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 border border-black/5 rounded-2xl pointer-events-none"></div>
                </div>

                <div className="flex items-center gap-[12px] md:gap-[16px] px-1 md:px-2">
                  <div className="w-10 h-10 rounded-full bg-blue-50 text-blue-600 flex items-center justify-center border border-blue-100 shrink-0 group-hover:bg-brand-gradient group-hover:text-white transition-all duration-300">
                    <SafeIcon name={project.iconName} className="w-4 h-4" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-slate-900 text-[16px] md:text-[18px] font-bold leading-[1.4] line-clamp-1 group-hover:text-brand-gradient transition-all duration-300">
                      {project.title}
                    </h3>
                    <div className="flex items-center gap-[12px] mt-1">
                      <span className="text-slate-500 text-[11px] md:text-[12px] font-medium flex items-center gap-1 group-hover:text-slate-700 transition-colors">
                        <SafeIcon name="Eye" className="w-3 h-3" />
                        {project.views}
                      </span>
                      <span className="text-slate-500 text-[11px] md:text-[12px] font-medium flex items-center gap-1 group-hover:text-red-500 transition-colors">
                        <SafeIcon name="Heart" className="w-3 h-3" />
                        {project.likes}
                      </span>
                      <span className="text-slate-400 text-[11px] ml-auto font-medium bg-slate-100 px-2 py-0.5 rounded-full">
                        {project.category}
                      </span>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </AnimatePresence>
        </motion.div>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, delay: 0.2 }}
        className="relative col-span-full mt-4 md:mt-8 overflow-hidden z-30"
      >
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[24px] max-w-[1248px] mx-auto px-6 md:px-12 lg:px-24">
          <div className="hidden md:block h-[240px] md:h-[280px] border-t border-x border-slate-200 bg-gradient-to-b from-white via-white to-transparent rounded-t-2xl opacity-80 shadow-sm"></div>
          <div className="h-[240px] md:h-[280px] border-t border-x border-slate-200 bg-gradient-to-b from-white via-white to-transparent rounded-t-2xl opacity-80 shadow-sm mx-auto w-full max-w-[400px]"></div>
          <div className="hidden lg:block h-[240px] md:h-[280px] border-t border-x border-slate-200 bg-gradient-to-b from-white via-white to-transparent rounded-t-2xl opacity-80 shadow-sm"></div>
        </div>

        <div className="absolute inset-0 flex items-start pt-16 justify-center z-20 px-6">
          <button
            onClick={() => navigate('/portfolio')}
            className="flex items-center justify-center gap-2 bg-brand-gradient text-white px-8 md:px-12 py-3 md:py-4 rounded-full font-bold hover:opacity-90 hover:shadow-lg hover:shadow-blue-600/20 active:scale-[0.98] transition-all whitespace-nowrap"
          >
            <span className="text-[16px] md:text-[18px] tracking-tight">Browse all work</span>
            <SafeIcon name="ArrowRight" className="w-5 h-5 stroke-[2.5px]" />
          </button>
        </div>

        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-slate-50 z-10 pointer-events-none"></div>
        <div className="absolute bottom-0 left-0 right-0 h-[150px] bg-gradient-to-t from-slate-50 to-transparent z-30 pointer-events-none"></div>
      </motion.div>
    </section>
  );
};

export default PortfolioSection;